module.exports = require("core-js/modules/es.array.unscopables.flat-map.js");